import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator"

overrideIfMinBetNumberEnabled(function () {

    (function (multiOptions) {
        if (multiOptions.length === 0) { return; }

        multiOptions.forEach(function (multiOption) {
            var _getUKBetSlipOptions = multiOption.getUKBetSlipOptions;

            $.extend(multiOption, {
                getUKBetSlipOptions (mode, selections, options, customOptions) {
                    var baseOptions = _getUKBetSlipOptions(mode, selections, options, customOptions);
                    return $.extend(baseOptions, { isMinBetNumberValid: mode.validateMinBetNumber(selections, baseOptions) });
                }
            });
        });
    })([window.TResponsiveMultiOptions, window.TRegularMultiOptions]); // looks like TRegularMultiOptions is obsolete

});